import { Span } from '@fareye/ui'
import { FaMapMarked, getValueFromNestedKey } from '@fareye/utils'
import React from 'react'
import { formatters } from '../../../../config/constants'
import { ColFullHeight } from '../../../../style/styled'
import { IColumnConfig } from '../../../../utility/types'
import { useTranslation, parseTemperature, parseDoorData } from '@fareye/common'

function getHeaders({label,key,t}:any) {
  if (key=='transitTime' || key=='loadingTat' || key=='unloadingTat'){
    return label
  }
  return t(label)
}

function generateColumnObject(column: IColumnConfig, { t, i18n }: any) {
  //TODO: Add Tracking column
  let { label, key, formatter, link = '/in-transit/trips' } = column
  //   NOTE: Remove this code once subtype is resolved
  const isMobi = location?.pathname.includes('/v2/view')
  link = isMobi ? (link = `/v2/view${link}`) : link
  switch (key) {
    case 'tracking':
      return {
        Header: t(label),
        id: key,
        width: 60,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="slug">
            <a target="_blank" href={`${link}/${original['slug']}`}>
              <FaMapMarked color="rgba(24,144,255,1)" />
            </a>
          </ColFullHeight>
        )
      }
    case 'link':
      return {
        Header: t(label),
        id: key,
        width: 60,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="slug">
            <a target="_blank" href={`${link}/${original['slug']}`}>
              <FaMapMarked color="rgba(24,144,255,1)" />
            </a>
          </ColFullHeight>
        )
      }
    case 'hasMultiVehicle':
      return {
        Header: t(label),
        id: key,
        width: 100,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="hasMultiVehicle">
            <Span variant="ellipsis">
              {original.hasMultiVehicle ? t('Yes') : t('No')}
            </Span>
          </ColFullHeight>
        )
      }
    case 'parcelLink':
      return {
        Header: t(label),
        id: key,
        width: 160,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <a target="_blank" href={`${link}/${original['parcelDigest']}`}>
              {<Span color="rgba(24,144,255,1)">{original['trackingId']}</Span>}
            </a>
          </ColFullHeight>
        )
      }
    case 'videoLink':
    case 'imageLink':
      return {
        Header: t(label),
        id: key,
        width: 60,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => {
          const value = original?.[key]
          return (
            <ColFullHeight>
              {(value) ? (
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Click here to open"
                  style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                >
                  {key === 'videoLink' ? 'Video' : 'Image'}
                </a>
              ) : (
                <Span>-</Span>
              )}
            </ColFullHeight>
          )
        }
      }

    default:
      return {
        Header: getHeaders({label, key, t}),
        id: key,
        width: 100,
        accessor: key,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          let formattedValue =
            formatter && formatters[formatter]
              ? (value && formatters[formatter](value)) || '-'
              : (!!value && typeof value === 'string' ? t(value, value) : value) ||
                (value === 0 ? 0 : '-')
          if (formatter === 'startCase') {
            formattedValue = t(formattedValue)
          }
          if (key === 'extraData.temperature') {
            formattedValue = formattedValue === '-' ? null : formattedValue
            formattedValue = parseTemperature(
              formattedValue ??
                getValueFromNestedKey(original, 'extraData.sensorData')
            )
            formattedValue = `${formattedValue}`
          }
          if (key === 'extraData.doors') {
            formattedValue = parseDoorData(
              getValueFromNestedKey(original, 'extraData.sensorData')
            )
          }
          return (
            <ColFullHeight data-testid={key}>
              <Span variant="ellipsis">{formattedValue}</Span>
            </ColFullHeight>
          )
        }
      }
  }
}
export function getTableColumns(
  reqdColumns: IColumnConfig[],
  propsConfig?: any
) {
  const COLUMNS = reqdColumns.map(ele => generateColumnObject(ele, propsConfig))
  return COLUMNS
}
